import useTinySettings from 'hooks/use-tiny-settings';
const useTinyViewer = (enableWiris = false) => {
    const { getWirisSetting } = useTinySettings();
    const createInitialContent = () => {
        const wirisViewerUrl = enableWiris ? getWirisSetting('viewerUrl') : '';
        return `
      <!DOCTYPE html>
      <html>
        <head>
        <link type="text/css" rel="stylesheet" href="https://cdn.tiny.cloud/1/kdsi0dycn4pq62nxenf4zbb3iqayj68ly6zxpt7czz5lb33p/tinymce/6.1.2-8/skins/ui/oxide/content.min.css" crossorigin="anonymous">
        <link type="text/css" rel="stylesheet" href="https://cdn.tiny.cloud/1/kdsi0dycn4pq62nxenf4zbb3iqayj68ly6zxpt7czz5lb33p/tinymce/6.1.2-8/skins/content/default/content.min.css" crossorigin="anonymous">
        <script src="${wirisViewerUrl}"></script>
        <style type="text/css">
          img { max-width: 100% !important; height: auto; }
        </style>
        <base target="_blank">
        </head>
        <body id="tinymce" class="mce-content-body">
          <div id="mountTarget"></div>
        </body>
      </html>
    `;
    };
    return { createInitialContent };
};
export default useTinyViewer;
